/**
 * PDF im Modal: Desktop nutzt iframe (Toolbar per CSS ausgeblendet).
 * Mobile/iOS: <embed> – iframe-Vorschau ist dort oft unzuverlässig.
 */
export function isPdfBlobUrl(src = "") {
  return String(src || "").trim().startsWith("blob:");
}

export function shouldPreferPdfEmbed(src = "", { mobileLike = false } = {}) {
  void src;
  return Boolean(mobileLike);
}
